
import { IRequestDetailEditService } from '../services/requestDetailEditService';
import { RequestDetailEdit } from '../models/requestDetailEdit';
import { RequestPickupDetail } from '../models/requestPickupDetail';
import { requestsState } from '../../requests/requestsState';
import { addRequestState } from '../../addRequest/states/addRequestState';
import { IChangeTrackingService } from '../../../changeTracking/iChangeTrackingService';
import { IChangeTracking } from '../../../changeTracking/iChangeTracking';
import { SaveResult } from '../../../../core/saveResult';
import { ISessionService } from '../../../../core/sessions/sessionService';
import { IMessageService } from "../../../../core/messageService";
import {RequestAssignedMaterialToPackage } from "../models/requestAssignedMaterialToPackage";
import {INotificationService } from '../../../../core/notificationService';
import { requestDetailEditState } from "../states/requestDetailEditState";
import {RequestLetter} from "../../requestDetail/models/requestLetter";
import {IRequestDetailService} from  "../../requestDetail/services/requestDetailService";

export class RequestDetailEditController implements IChangeTracking, ng.IController {

    static $inject = [
        'requestDetailEditService', 'ChangeTrackingService', '$state', '$stateParams', '$scope', '$mdMedia',
        'SessionService', 'MessageService', '$mdDialog', '$rootScope', 'NotificationService', '$filter', 'requestDetailService'
    ];
    private _isLoading: boolean;
    private _trackingId: number;
    private _requestDetailsEdit: RequestDetailEdit;
    isShipmentDetailLoading: boolean;
    isMaterialLoading: boolean;
    isMaterialValid: boolean;
    isShipmentDetailValid : boolean;
    unmodifiedRequestDetailEdit: RequestDetailEdit;
    usTerritories = ['US', 'AS', 'GU', 'MP', 'PR', 'VI'];
    onClickCheck = false;
    onClickMessage = ''

    constructor(private _requestDetailEditService: IRequestDetailEditService,
        private _changeTrackingService: IChangeTrackingService,
        protected _$state: angular.ui.IStateService,
        private _$stateParams: angular.ui.IStateParamsService,
        private _$scope: angular.IScope,
        private _$mdMedia: angular.material.IMedia,
        private _sessionService: ISessionService,
        private _messageService: IMessageService,
        private _$mdDialog: ng.material.IDialogService,
        private _$rootScope: ng.IRootScopeService,
        private _notificationService: INotificationService,
        private $filter: ng.IFilterService,
        private requestDetailService: IRequestDetailService
    ) {
    }

    $onInit() {
        this._trackingId = this._$stateParams['trackingId'];
        this._isLoading = true;
        this._requestDetailEditService.getDetail(this._trackingId,true).then(v => this.handleGetDetail(v));
        this._changeTrackingService.initializeTracking(this);
    }

    public canSaveRequestDetailEditForm(form: angular.IFormController): boolean {
        
        return (this.isRequestHasChanges() && this.isRequestValid()); 
    }

    isRequestValid(): boolean {
        return this.isShipmentDetailValid && this.isMaterialValid;
    }


    get trackingId(): number {
        return this._requestDetailsEdit ? this._requestDetailsEdit.trackingId : undefined;
    }

    private handleGetDetail(details: RequestDetailEdit): void {
        this._isLoading = false;
        if (details.errorMessage !== null && details.errorMessage !== undefined && details.errorMessage.length > 0) {
            this._notificationService.showToastWithMentionedDelay(details.errorMessage, 5000);
        } else {
            var requestInitialLoadRequestDetailEdit = angular
                .copy(this.setIdValuesToUndefinedOnRequestDetailEditLoad(angular.copy(details)));
            this._requestDetailsEdit = angular.copy(this
                .loadAllPackagesWithAssignedQuantityToAssignMaterials(angular
                    .copy(requestInitialLoadRequestDetailEdit)));
            this.unmodifiedRequestDetailEdit = angular.copy(this._requestDetailsEdit);
        }
       

        
        this._$scope.$apply();
    }

    private setIdValuesToUndefinedOnRequestDetailEditLoad(details: RequestDetailEdit): RequestDetailEdit {
        if (details !== undefined) {
           
            if (details.requestDetail !== undefined && details.requestDetail.requestPickupDetail !== undefined) {
                details.requestDetail.requestPickupDetail.pickupId = angular.copy(undefined);
            }


            if (details.requestDetail !== undefined && (details.requestDetail.requestPickupDetail === undefined ||
                details.requestDetail.requestPickupDetail === null)) {
                details.requestDetail.requestPickupDetail = new RequestPickupDetail(undefined);
            }

            if (details.requestMaterial !== undefined) {
                if (details.requestMaterial.requestMaterials !== undefined) {
                    for (var im = 0; im < details.requestMaterial.requestMaterials.length; im++) {
                        if (details.requestMaterial.requestMaterials[im] !== undefined) {
                            details.requestMaterial.requestMaterials[im].materialId = angular.copy(undefined);
                        }
                    }
                }

                if (details.requestMaterial.requestPackages !== undefined) {
                    for (var ip = 0; ip < details.requestMaterial.requestPackages.length; ip++) {
                        if (details.requestMaterial.requestPackages[ip] !== undefined) {
                            details.requestMaterial.requestPackages[ip].packageId = angular.copy(undefined);
                            details.requestMaterial.requestPackages[ip].quantity = angular.copy(undefined);
                        }
                    }
                }


                if (details.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
                    for (var ia = 0; ia < details.requestMaterial.requestAssignedMaterialToPackage.length; ia++) {
                        if (details.requestMaterial.requestAssignedMaterialToPackage[ia] !== undefined) {
                            if (details.requestMaterial.requestAssignedMaterialToPackage[ia].requestMaterials !==
                                undefined) {
                                details.requestMaterial.requestAssignedMaterialToPackage[ia].requestMaterials
                                    .materialId = angular.copy(undefined);
                            }

                            if (details.requestMaterial.requestAssignedMaterialToPackage[ia].requestPackages !==
                                undefined) {
                                for (var iap = 0;
                                    iap <
                                    details.requestMaterial.requestAssignedMaterialToPackage[ia].requestPackages
                                        .length;
                                    iap++) {
                                    if (details.requestMaterial.requestAssignedMaterialToPackage[ia]
                                        .requestPackages[iap] !==
                                        undefined) {
                                        details.requestMaterial.requestAssignedMaterialToPackage[ia]
                                            .requestPackages[iap]
                                            .packageId = angular.copy(undefined);
                                    }
                                }
                            }
                        }
                    }
                }


               


            }

        }

        return details;
    }

    private loadAllPackagesWithAssignedQuantityToAssignMaterials(loadAssignMaterialsRequestDetailEdit: RequestDetailEdit):
        RequestDetailEdit {

        var packagesLoadRequestDetailEdit = this.loadAllPackagesToAssignMaterials(
            angular.copy(loadAssignMaterialsRequestDetailEdit));
        return this.loadAssignedPackagesToAssignMaterial(angular.copy(packagesLoadRequestDetailEdit),
            angular.copy(loadAssignMaterialsRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage));

    }

    private loadAllPackagesToAssignMaterials(loadAllRequestDetailEdit: RequestDetailEdit): RequestDetailEdit {

        if (loadAllRequestDetailEdit !== undefined &&
            loadAllRequestDetailEdit.requestMaterial !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestPackages !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestMaterials !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
            for (var iamp = 0;
                iamp < loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length;
                iamp++
            ) {

                loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iamp].requestPackages = [];
                loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iamp].requestPackages = angular
                    .copy(loadAllRequestDetailEdit.requestMaterial.requestPackages);
            }
        }

        return loadAllRequestDetailEdit;
    }

    private loadAssignedPackagesToAssignMaterial(rqDetailEdit: RequestDetailEdit,
        copyRequestAssignedMaterialToPackages: RequestAssignedMaterialToPackage[]): RequestDetailEdit {


        if (rqDetailEdit !== undefined &&
            rqDetailEdit.requestMaterial !== undefined &&
            rqDetailEdit.requestMaterial.requestPackages !== undefined &&
            rqDetailEdit.requestMaterial.requestMaterials !== undefined &&
            rqDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {


            for (var iamp = 0; iamp < rqDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iamp++) {


                for (let eachcopyAssignedPackage of copyRequestAssignedMaterialToPackages[iamp].requestPackages) {

                    for (let eachUnAssignedPackage of rqDetailEdit.requestMaterial
                        .requestAssignedMaterialToPackage[iamp].requestPackages) {

                        if (eachUnAssignedPackage.recordNumber === eachcopyAssignedPackage.recordNumber) {

                            eachUnAssignedPackage.quantity =
                                angular.copy(eachcopyAssignedPackage.quantity);
                            eachUnAssignedPackage.packageId =
                                angular.copy(eachcopyAssignedPackage.packageId);
                        }
                    }

                }

            }
        }

        return rqDetailEdit;
    }


    get isLoading(): boolean {
        return this._isLoading || this.isMaterialLoading || this.isShipmentDetailLoading;
    }

   
    


    get requestDetailEdit(): RequestDetailEdit {
        return this._requestDetailsEdit;
    }

    
    
    
    private extractError(result) {
        return (result && result.errors && result.errors.length > 0) ? result.errors[0] : 'Unexpected error occurred';
    }

    copyRequest(trackingId: number): void {
        this._isLoading = true;
        this._requestDetailEditService.getDetail(this.trackingId,false).then(v => this.handleCopyGetDetail(v));
    }

    private handleCopyGetDetail(details: RequestDetailEdit): void {
      
        this._isLoading = false;
        if (details.errorMessage !== null && details.errorMessage !== undefined && details.errorMessage.length > 0) {
            this._notificationService.showToastWithMentionedDelay(details.errorMessage, 5000);
        } else {
            this._$state.go(addRequestState.name, { copyRequestDetailEdit: details });
        }
    }

    downloadSpreadSheet(trackingId: number): void {
        this._isLoading = true;
        this._requestDetailEditService.downloadSpreadSheet(trackingId).then(r => {
          
            if (r.byteLength === 0) {
                this._notificationService
                    .showToastWithMentionedDelay("REQUEST NOT FOUND - An Administrator Has Deleted This Shipment Request", 5000);
            } else {
                var byteArray = new Uint8Array(r);
                var blob = new Blob([byteArray],
                    { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = trackingId + '.xlsx';
                link.click();
            }
            this._isLoading = false;
        }, (r) => {
            this._isLoading = false;
            this._notificationService.showToast("Unable to Download Attachment, Technical Error Has Occured!");

        });
        
    }

    generatePreShipmentRequestLetter(letterTrackingId: number, ev): void {

        const confirm = this._$mdDialog.confirm()
            .parent(angular.element(document.body))
            .textContent('Are you sure you would like to Print this Request?')
            .ok('Ok')
            .cancel('Cancel')
            .targetEvent(ev);
        this._$mdDialog.show(confirm)
            .then(() => {
                this._isLoading = true;
                this.generateprintpdf(letterTrackingId);
                

            });
    }

    private generateprintpdf(letterTrackingId: number): void {
        this.requestDetailService.getDetail(letterTrackingId, false)
            .then(r => {

                if (r !== undefined &&
                    r !== null &&
                    r.errorMessage !== null &&
                    r.errorMessage !== undefined &&
                    r.errorMessage.length > 0) {
                    this._isLoading = false;
                    this._notificationService.showToastWithMentionedDelay(r.errorMessage, 5000);
                } else {
                    
                    
                    this.requestDetailService.generateRequestLetterByTrackingId(this._trackingId)
                        .then(r => {
                                if (r.byteLength === 0) {
                                    this._notificationService
										.showToastWithMentionedDelay("PDF generation in progress, please wait. If you see this message after several minutes, please contact support.",
                                            5000);
                                } else {
                                    var byteArray = new Uint8Array(r);
                                    var file = new Blob([byteArray], { type: 'application/pdf' });
                                    const fileUrl = URL.createObjectURL(file);
                                    window.open(fileUrl);

                                }
                                this._isLoading = false;
                                this._$scope.$apply();

                            },
                        (r) => {
                            this.handleSaveError(r);
                            this._isLoading = false;
                            this._$scope.$apply();
                        });
                } // else 
            });
    }

    processEmail(emailTrackingId : number, ev: MouseEvent): void {

        const confirm = this._$mdDialog.confirm()
            .parent(angular.element(document.body))
            .textContent('Are you sure you would like to Process Email for this Request?')
            .ok('Ok')
            .cancel('Cancel')
            .targetEvent(ev);
        this._$mdDialog.show(confirm)
            .then(() => {
                this._isLoading = true;
                this.processEmailForTrackingId(emailTrackingId);


            });

    }

    private processEmailForTrackingId(emailTrackingId: number): void {
        this.requestDetailService.getDetail(emailTrackingId, false)
            .then(r => {

                if (r !== undefined &&
                    r !== null &&
                    r.errorMessage !== null &&
                    r.errorMessage !== undefined &&
                    r.errorMessage.length > 0) {
                    this._isLoading = false;
                    this._notificationService.showToastWithMentionedDelay(r.errorMessage, 5000);
                } else {


                    this.requestDetailService.processEmailRequestByTrackingId(this._trackingId)
                        .then(r => {
                            this._notificationService.showToastWithMentionedDelay("Email Processing Triggered Successfully", 5000);
                            this._isLoading = false;
                            this._$scope.$apply();
                        },
                        (r) => {
                            this.handleSaveError(r);
                            this._isLoading = false;
                            this._$scope.$apply();
                        });
                }  
            });

    }


    isTransportModeLtlValid(): boolean {

        if (this.shipmentNotUndefined() && this.consigneeNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestShipment.transportMode !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee.countryCode !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.transportMode.toUpperCase() === "LTL") {

            var countryCode = this.requestDetailEdit.requestDetail.requestConsignee.countryCode.toUpperCase();

            if (countryCode === "US" ||
                countryCode === "CA" ||
                countryCode === "PR") {
                return true;
            } else {
                return false;
            }
        }

        return true;
    }

    shipmentNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined;
    }

    consigneeNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee !== undefined;
    }

    hasChanges(): boolean {
        return this._requestDetailsEdit && this.isRequestHasChanges();
    }

    isRequestHasChanges(): boolean {
        
            var unmodifiedRequestDetailEdit = angular.copy(this
                .getJsonFormatOfRequestDetailEditModel(angular.copy(this.unmodifiedRequestDetailEdit)));
            var modifiedRequestDetailEdit = angular.copy(this
                .getJsonFormatOfRequestDetailEditModel(angular.copy(this.requestDetailEdit)));

            return !angular.equals(unmodifiedRequestDetailEdit, modifiedRequestDetailEdit);
       
    }

    save(form: angular.IFormController) {
       
        if (!this.isRequestedDeliveryDateAndShipmentReadyDateValid()) {
            this._notificationService
                .showToastWithMentionedDelay('The Shipment Ready Date must occur before the Requested Delivery Date.',5000);
            return false;
        }
       else if (!this.isAssignMaterialsToPackgesValid()) {
            this._notificationService
                .showToastWithMentionedDelay('In Materials Tab, Section "Assign Materials to Packages" is Invalid',5000);
            return false;
        }
        else if (!this.isTransportModeLtlValid()) {
            this._notificationService
                .showToastWithMentionedDelay('LTL can only be selected for Shipments to the US, Canada or Puerto Rico.',5000);
            return false;

        } else if (this.isNotAssignedPackagesExist()) {
            this._notificationService
                .showToastWithMentionedDelay('There are Unassigned Packages in Assign Materials. Please remove or assign materials to these packages.',5000);
            return false;
        } else if (this.isGrossWeightLessThanTotalNetWeight()) {
            this._notificationService
                .showToastWithMentionedDelay('Total Gross Weight per Package cannot be less than the Total Net Weight of the Materials assigned to the Package. Revise the Gross OR Net weight accordingly', 7000);
            return false;
        } else if (this.requestDetailEdit.requestDetail.requestShipment.isAssetValue === 'Yes' &&
            this.requestDetailEdit.requestDetail.requestShipment.isFAMRValue === 'No') {
            this._notificationService
                .showToastWithMentionedDelay('You should have completed FAMR if the material is an asset', 7000);
            return false;
        } else if ((this.usTerritories.indexOf(this.requestDetailEdit.requestDetail.requestConsignee.countryCode) < 0
            || this.usTerritories.indexOf(this.requestDetailEdit.requestDetail.requestPickupDetail.countryCode) < 0)
            && (!this.requestDetailEdit.requestDetail.requestShipment.chargeToConsignee)
            && (this.requestDetailEdit.requestDetail.requestShipment.isAsset)) {            
            this._notificationService
                .showAlertWithOk('Application of charges is required for asset shipments when "Ship To" or "Ship From" address is outside the US and its territories. Please adjust shipping address(es) or apply charges');
            return false;
        }
        else if (this.requestDetailEdit.requestDetail.requestShipment.isAsset &&
            (this.requestDetailEdit.requestMaterial.requestMaterials[0].assetNumber === null
            || this.requestDetailEdit.requestMaterial.requestMaterials[0].modelNo === null
            || this.requestDetailEdit.requestMaterial.requestMaterials[0].yearAcquired === null
            || this.requestDetailEdit.requestMaterial.requestMaterials[0].yearAcquired === 0)) {
            this._notificationService
                .showAlertWithOk('If shipment is an asset then material asset number, model number, year acquired are required');
            return false;
        }
        else
            this.performSave();
    }

    private isGrossWeightLessThanTotalNetWeight(): boolean {
        var grossWeight = 0;
        var assignedQuantity = 0;
        var assignedWeight = 0;
        var materialNetWeight = 0;
        var packages = [];

        for (var i = 0; i < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; i++) {
            for (var j = 0; j < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages.length; j++) {

                materialNetWeight = this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestMaterials.netWeight;
                materialNetWeight = (materialNetWeight == null || materialNetWeight == undefined) ? 0 : materialNetWeight;

                grossWeight = this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages[j].grossWeight;
                grossWeight = (grossWeight == null || grossWeight == undefined) ? 0 : grossWeight;

                assignedQuantity = this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages[j].quantity;
                assignedQuantity = (assignedQuantity == null || assignedQuantity == undefined) ? 0 : assignedQuantity;

                assignedWeight = assignedQuantity * materialNetWeight;

                if (i == 0) {
                    var pkg = { id: j, packageGrossWeight: grossWeight, assignedMaterialWeight: assignedWeight };
                    packages.push(pkg);
                }
                else {
                    var existingPkg = this.$filter('filter')(packages, function (d) { return d.id === j; })[0];
                    existingPkg.assignedMaterialWeight = existingPkg.assignedMaterialWeight + assignedWeight;
                }
            }
        }

        for (let pkg of packages) {
            if (pkg.packageGrossWeight < pkg.assignedMaterialWeight)
                return true;
        }

        return false;
    }

    private isRequestedDeliveryDateAndShipmentReadyDateValid(): boolean {
        if (this.shipmentNotUndefined() &&
            this.requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate !== undefined && 
            this.requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate < this.requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate) {
            return true;
        }

        return false;
    }

    private performSave(): void {

        this._isLoading = true;

        const requestLetterHtml = document.getElementById('request-letter').innerHTML;
        this.requestDetailEdit.requestLetter = new RequestLetter(requestLetterHtml, this.requestDetailEdit.requestDetail.requestShipment.userName, this.trackingId, this.requestDetailEdit.requestDetail.requestShipment.submittedDate);
        
        this._requestDetailEditService
            .save(angular.copy(this.getJsonFormatOfRequestDetailEditModel(angular.copy(this.requestDetailEdit))))
            .then(r => this.handleSaveSuccess(r), r => this.handleSaveError(r.data));
    }
    private handleSaveSuccess(result: SaveResult): void {
       
        this._isLoading = false;

        if (result.errors && result.errors.length > 0) {
            this._notificationService.showToastWithMentionedDelay(result.errors.join('\n'), 5000);
        } else {
            var isConsigneeChanged = angular.equals(
                angular.copy(this.getJsonFormatOfRequestConsignee(angular.copy(this.unmodifiedRequestDetailEdit))),
                angular.copy(this.getJsonFormatOfRequestConsignee(angular.copy(this.requestDetailEdit))));
            this.requestDetailEdit.rowVersion = result.rowVersion;
            this.unmodifiedRequestDetailEdit = angular.copy(this.requestDetailEdit);
            this._messageService.publish('RequestSaved', this.requestDetailEdit);
            this._notificationService.showToast('Request saved.');
            if (!isConsigneeChanged) {
                this._$state.reload();
            }
        }
    }


    private handleSaveError(saveResult): void {
       
        this._isLoading = false;
        this._notificationService.showToastWithMentionedDelay(this.extractError(saveResult), 5000);
    }

    private isNotAssignedPackagesExist(): boolean {

        if (this.requestDetailEdit !== undefined && this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestPackages !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
            let assignedRequestPackagesRecordNumber: Array<number> = [];
            for (let eachRequestAssignedMaterialToPackage of
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage) {
                for (let recordNumber of eachRequestAssignedMaterialToPackage.requestPackages
                    .filter(o => (o.quantity !== undefined && o.quantity !== null && o.quantity > 0 && !o.isDeleted)).map(o => o.recordNumber)) {
                    if (assignedRequestPackagesRecordNumber.filter(o => o === recordNumber).length === 0) {
                        assignedRequestPackagesRecordNumber.push(recordNumber);
                    }
                }

            }

            let allRequestPackagesRecordNumber: Array<number> = [];
            allRequestPackagesRecordNumber = angular.copy(this.requestDetailEdit.requestMaterial.requestPackages
                .filter(o => !o.isDeleted).map(o => o.recordNumber));


            let unAssignedPackagesRecordNumber = _
                .difference(allRequestPackagesRecordNumber.sort(), assignedRequestPackagesRecordNumber.sort());

            if (unAssignedPackagesRecordNumber !== undefined &&
                unAssignedPackagesRecordNumber !== null &&
                unAssignedPackagesRecordNumber.length === 0) {
                return false;
            }

        }

        return true;
    }

    private isAssignMaterialsToPackgesValid(): boolean {
        if (this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length > 0) {
            let isAssignToMaterialPackagesValid: boolean = false;
            for (var iam = 0; iam < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {
                if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam] !== undefined &&
                    this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials !== undefined &&
                    !this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials.isDeleted) {

                    if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam]
                        .requestMaterials.quantity ===
                        this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].assignedPc) {
                        isAssignToMaterialPackagesValid = true;
                    } else {
                       
                        return false;
                    }

                }
            }

            return isAssignToMaterialPackagesValid;

        }
        return false;

    }

    deleteRequest(trackingIdTobeDeleted : number, ev ): void {
        const confirm = this._$mdDialog.confirm()
            .parent(angular.element(document.body))
            .title('Are you sure?')
            .textContent('Deleting a request cannot be undone. Do you want to continue?')
            .ok('DELETE')
            .cancel('CANCEL')
            .targetEvent(ev);
        this._$mdDialog.show(confirm)
            .then(() => {
                this._requestDetailEditService.deleteRequest(trackingIdTobeDeleted)
                    .then(() => {
                        this._$state.go(requestsState.name, {}, { reload: true });
                        this._notificationService.showToast('Request deleted');
                    },
                    (result: {}) => {
                        this._notificationService.showToast(this.extractError(result));
                    });
            });
    }

    public openMoreOptions($mdOpenMenu,ev): void {
        $mdOpenMenu(ev);
    }

    getJsonFormatOfRequestConsignee(requestDetailEdit: RequestDetailEdit): any {
        
        if (requestDetailEdit !== undefined && requestDetailEdit.requestDetail !== undefined &&
            requestDetailEdit.requestDetail.requestConsignee !== undefined) {
            return angular.copy(requestDetailEdit.requestDetail.requestConsignee.toJson());
        }
        return "";
    }

    getJsonFormatOfRequestDetailEditModel(requestDetailEdit: RequestDetailEdit): any {
        var trackingId;
        if (requestDetailEdit !== undefined && requestDetailEdit.trackingId !== undefined) {
            trackingId = requestDetailEdit.trackingId;
        }

        var rowVersion;
        if (requestDetailEdit !== undefined && requestDetailEdit.rowVersion !== undefined) {
            rowVersion = requestDetailEdit.rowVersion;
        }

        var requestShipment;
        if (requestDetailEdit !== undefined && requestDetailEdit.requestDetail !== undefined &&
            requestDetailEdit.requestDetail.requestShipment !== undefined) {
            requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate = angular.copy(this
                .formatDateWithTimeZone(angular.copy(requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate)));
            requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate = angular.copy(this
                .formatDateWithTimeZone(angular.copy(requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate)));
            requestShipment = requestDetailEdit.requestDetail.requestShipment.toJson();
        }

        var requestConsignee;
        if (requestDetailEdit !== undefined && requestDetailEdit.requestDetail !== undefined &&
            requestDetailEdit.requestDetail.requestConsignee !== undefined) {
            requestConsignee = requestDetailEdit.requestDetail.requestConsignee.toJson();
        }
        var requestPickupDetail;
        if (requestDetailEdit !== undefined && requestDetailEdit.requestDetail !== undefined &&
            requestDetailEdit.requestDetail.requestPickupDetail !== undefined) {
            requestPickupDetail = requestDetailEdit.requestDetail.requestPickupDetail.toJson();
        }
        var requestDetail = { requestShipment, requestConsignee, requestPickupDetail };

        var requestMaterials = [];

        if (requestDetailEdit !== undefined && requestDetailEdit.requestMaterial !== undefined &&
            requestDetailEdit.requestMaterial.requestMaterials !== undefined) {
            for (var im = 0; im < requestDetailEdit.requestMaterial.requestMaterials.length; im++) {
                requestMaterials[im] = requestDetailEdit.requestMaterial.requestMaterials[im].toJson();
            }
        }

        var requestPackages = [];

        if (requestDetailEdit !== undefined && requestDetailEdit.requestMaterial !== undefined &&
            requestDetailEdit.requestMaterial.requestMaterials !== undefined) {
            for (var ip = 0; ip < requestDetailEdit.requestMaterial.requestPackages.length; ip++) {
                requestPackages[ip] = requestDetailEdit.requestMaterial.requestPackages[ip].toJson();
            }
        }

        var requestAssignedMaterialToPackage = [];

        if (requestDetailEdit !== undefined && requestDetailEdit.requestMaterial !== undefined &&
            requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
            for (var iam = 0; iam < requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {

                var assignedPc = requestDetailEdit.requestMaterial
                    .requestAssignedMaterialToPackage[iam].assignedPc;

                var requestMaterialEdit = requestDetailEdit.requestMaterial
                    .requestAssignedMaterialToPackage[iam].requestMaterials.toJson();

                var packages = [];
                var indexOfPackages = 0;
                for (var iamp = 0; iamp < requestDetailEdit.requestMaterial
                    .requestAssignedMaterialToPackage[iam].requestPackages.length; iamp++) {

                    if (requestDetailEdit.requestMaterial
                        .requestAssignedMaterialToPackage[iam].requestPackages[iamp] !==
                        undefined &&
                        requestDetailEdit.requestMaterial
                            .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity !==
                        undefined &&
                        requestDetailEdit.requestMaterial
                            .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity !==
                        null &&
                        requestDetailEdit.requestMaterial
                            .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity >
                        0
                    ) {

                        packages[indexOfPackages] = requestDetailEdit.requestMaterial
                            .requestAssignedMaterialToPackage[iam].requestPackages[iamp].toJson();
                        indexOfPackages = indexOfPackages + 1;
                    }
                }

                requestAssignedMaterialToPackage[iam] = { assignedPc, requestMaterialEdit, packages }
            }
        }

      

        var shipmentRequestLetter;
        if (requestDetailEdit !== undefined && requestDetailEdit.requestLetter !== undefined) {
            shipmentRequestLetter = requestDetailEdit.requestLetter.toJSON();
        }

        var requestMaterial = { requestMaterials, requestPackages, requestAssignedMaterialToPackage };
        var rqDetailEdit = { trackingId, requestDetail, requestMaterial, rowVersion, shipmentRequestLetter };
        return rqDetailEdit;

    }

    private formatDateWithTimeZone(date: Date): Date {
        return (this.$filter("date")(date, "yyyy-MM-dd")) as any;
    }

}

angular.module('deliveryCreate.app').controller('RequestDetailEditController', RequestDetailEditController);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/controllers/requestDetailEditController.ts
 **/